import { Box, Button, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/logo.svg";
import UnauthorizedImage from "../assets/Unauthorized_Img.svg";

const Unauthorized = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        backgroundColor: theme.palette.mode === 'dark' ? '#1E1E1E' : '#fff',
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          mb: 4,
          width: "184px",
          height: "60px",
          "& img": {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }
        }}
      >
        <img src={Logo} alt="Spark Logo" />
      </Box>

      {/* 404 Image */}
      <Box
        sx={{
          mb: 4,
          width: "300px",
          height: "200px",
          "& img": {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }
        }}
      >
        <img src={UnauthorizedImage} alt="401 Unauthorized" />
      </Box>

      {/* Error Message */}
      <Typography
        variant="h4"
        sx={{
          color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#111827',
          fontWeight: "600",
          mb: 1,
        }}
      >
        Something is wrong
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: theme.palette.mode === 'dark' ? '#A1A1AA' : '#6B7280',
          mb: 3,
        }}
      >
        The page you are looking for was missing
      </Typography>

      {/* Button */}
      <Button
        variant="outlined"
        onClick={() => navigate("/dashboard")}
        sx={{
          color: theme.palette.mode === 'dark' ? '#4F46E5' : '#4F46E5',
          borderColor: theme.palette.mode === 'dark' ? '#4F46E5' : '#4F46E5',
          "&:hover": {
            borderColor: theme.palette.mode === 'dark' ? '#4338CA' : '#4338CA',
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(79, 70, 229, 0.1)' : 'rgba(79, 70, 229, 0.04)',
          },
        }}
      >
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default Unauthorized; 